/* Template: Accordion
   ========================================================================== */

template.accordion = () => {
	// if there is at least one accordion element
	if ($('.accordion').length) {

		// for every accordion (we might want multiple per page)
		$('.accordion').each(function() {

			var $thisAccordion = $(this);

			$thisAccordion.find('.icon').on({
				focusin: function() {
					template.accordion.action($(this), true);
				}
			});

			// user clicks accordion item heading
			$thisAccordion.on('click', '.accordion__item__heading', function(e) {
				e.preventDefault();
				template.accordion.action($(this), false);
			});

		});
	}
};

template.accordion.action = ($this, openOnly) => {
	var $thisAccordionItem = $this.closest('.accordion__item');

	// if closed, open the accordion item
	if (!$thisAccordionItem.hasClass('accordion__item--open')) {
		// open the clicked accordion
		$thisAccordionItem.addClass('accordion__item--open');

		// set the height
		var contentHeight = $thisAccordionItem.find('.accordion__item__content div').innerHeight();
		$thisAccordionItem.find('.accordion__item__content').css('height', contentHeight);
	} else if (!openOnly) {
		$thisAccordionItem.removeClass('accordion__item--open');

		// remove applied height
		$thisAccordionItem.find('.accordion__item__content').removeAttr('style');
	}
};
